
/**
 * Store all the constants here
 * Mock this file in test cases when needed.
 */

const { MODE: ENVIRONMENT } = import.meta.env;

export { ENVIRONMENT };
